import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import { IAppOnlyStore } from 'stores/AllStores';
import { CreateLeadProperties } from 'stores/Leads';
import { SavingIndicator, SavingIndicatorStatus } from 'components/indicator';
import { CreateNewLeadStatus } from 'common/interfaces/provider';

// Styles
const s = require('./CreateLeadForm.css');

// Component
@inject('store')
@observer
export class CreateLeadForm extends React.Component<IAppOnlyStore, {}> {
    public render() {
        const { leads } = this.props.store;

        return (
            <div className={s.container}>
                <div className={s.form}>
                    <input
                        autoFocus={true}
                        type="text"
                        placeholder="Provider ID"
                        value={leads.newLead.providerId}
                        onChange={this.handleNewLeadFieldsChange(
                            CreateLeadProperties.providerId
                        )}
                    />
                    <input
                        type="text"
                        placeholder="Legal business name"
                        value={leads.newLead.legalBusName}
                        onChange={this.handleNewLeadFieldsChange(
                            CreateLeadProperties.legalBusName
                        )}
                    />
                    <input
                        type="text"
                        placeholder="DBA (optional)"
                        value={leads.newLead.dba}
                        onChange={this.handleNewLeadFieldsChange(
                            CreateLeadProperties.dba
                        )}
                    />
                    <button
                        className="boxButton"
                        onClick={this.handleCreateClick}
                    >
                        Create
                    </button>
                </div>

                <div className={s.saving}>
                    <SavingIndicator
                        align="right"
                        labels={{
                            success: 'Lead created',
                            saving: 'Creating new lead...',
                            error:
                                leads.newLead.status ===
                                CreateNewLeadStatus.ProviderIdRequired
                                    ? 'Provider ID is required'
                                    : leads.newLead.status ===
                                      CreateNewLeadStatus.LegalBusNameRequired
                                    ? 'Legal business name is required'
                                    : 'Something went wrong, try again',
                        }}
                        status={
                            leads.newLead.status ===
                                CreateNewLeadStatus.LegalBusNameRequired ||
                            leads.newLead.status ===
                                CreateNewLeadStatus.ServerSideError
                                ? SavingIndicatorStatus.Error
                                : leads.newLead.status ===
                                  CreateNewLeadStatus.Success
                                ? SavingIndicatorStatus.Success
                                : leads.newLead.status ===
                                  CreateNewLeadStatus.Saving
                                ? SavingIndicatorStatus.Saving
                                : SavingIndicatorStatus.None
                        }
                    />
                </div>
            </div>
        );
    }

    @action private handleNewLeadFieldsChange = (
        property: CreateLeadProperties
    ) => (e: React.FormEvent<HTMLInputElement>) => {
        this.props.store.leads.newLead[property] = e.currentTarget.value;
        this.props.store.leads.newLead.status = CreateNewLeadStatus.None;
    };

    @action private handleCreateClick = () => {
        this.props.store.leads.createNewLead();
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/createlead/CreateLeadForm.tsx